module.exports = __webpack_public_path__ + "img/btnStatus3.df142768.png";